/* eslint-disable max-len */
import * as DG from 'datagrok-api/dg';
import { errInfo } from '../utils/err-info';
export const DEFAULT_FILES_LIB_PROVIDER_NAME = 'Files';
export async function findProviderWithLibraryName(providers, libraryName) {
    for (const provider of providers) {
        const libNames = await provider.listLibraries();
        if (libNames.includes(libraryName) || libNames.includes(`${libraryName}.json`))
            return provider;
    }
    return null;
}
export async function getMonomerLibHelper() {
    const funcList = DG.Func.find({ package: 'Bio', name: 'getMonomerLibHelper' });
    if (funcList.length === 0)
        throw new Error('Package "Bio" must be installed for MonomerLibHelper.');
    const res = (await funcList[0].prepare().call()).getOutputParamValue();
    return res;
}
export class MonomerSetPlaceholder {
    constructor(monomerLib, symbol, polymerType, monomerType, monomerLinks) {
        this.monomerLib = monomerLib;
        this.symbol = symbol;
        this.polymerType = polymerType;
        this.monomerType = monomerType;
        this.monomerLinks = monomerLinks;
        this.error = null;
        try {
            this.monomers = this.monomerLinks.map((mLink) => {
                const resM = this.monomerLib.getMonomer(this.polymerType, mLink.symbol);
                if (!resM)
                    throw new Error('Monomer not found: ');
                if (resM.lib?.source != mLink.source)
                    throw new Error(`Monomer '${symbol}' found in different library.`);
                return resM;
            });
        }
        catch (err) {
            const [errMsg, _errStack] = errInfo(err);
            this.error = errMsg;
            this.monomers = [];
        }
    }
}
export class MonomerSet {
    constructor(description, placeholders, source = undefined, error = undefined) {
        this.description = description;
        this.placeholders = placeholders;
        this.source = source;
        this.error = error;
    }
    updateSets(setList, reload = false) {
        if (reload)
            this.placeholders = [];
        for (const _set of setList)
            if (!_set.error)
                this._updateSetInt(_set);
        // TODO: File onChanged
    }
    _updateSetInt(set) {
        for (const setPh of set.placeholders)
            this.placeholders.push(setPh);
    }
}
//# sourceMappingURL=monomer-library.js.map